import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, IconButton, useMediaQuery, makeStyles, CssBaseline, Menu, MenuItem, Button, Typography } from '@material-ui/core';
import { Schedule, Person, Group, Room, RoomService, ImportContacts, MoreVert, EventSeat, GroupWork, Menu as MenuIcon, Assessment, LocalHospital, Receipt, Assignment } from '@material-ui/icons';
import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { clearTokens } from '../../services/local_storage_service';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';
import { connect } from 'react-redux';

const useStyles = makeStyles({
    toolbar: {
        '& a': {
            textDecoration: 'none'
        }
    },
	button: {
		color: '#fff',
		padding: '0 20px',
        '& span': {
            display: 'flex',
            flexDirection: 'column'
        }
	},
    buttonRight: {
        marginLeft: 'auto',
        '& span': {
            flexDirection: 'row'
        }
    }
});

const Header = ({ user }) => {
	const { toolbar, button, buttonRight } = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));

    const { isDoctor, isManager, isAdmin } = user;

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAddUserClick = () => {
        setAnchorEl(null);
        history.push(REACT_ROUTES.ADD_USER);
    }

    const handleSettings = () => {
        setAnchorEl(null);
        history.push(REACT_ROUTES.SETTINGS);
    }

    const handleExitClick = () => {
        clearTokens();
        history.push(REACT_ROUTES.HOME);
    }

    const renderDesktopToolbar = () => (
        matches && <Toolbar className={toolbar}>
            <Link to={REACT_ROUTES.SCHEDULER}>
                <IconButton className={button} edge="start" aria-label="scheduler">
                    <Schedule fontSize="large" />
                    <Typography variant="caption">
                        Zakazivanje
                    </Typography>
                </IconButton>
            </Link>
            {isDoctor === false &&
                <>
                    <Link to={REACT_ROUTES.WORKERS}>
                        <IconButton className={button} edge="start" aria-label="scheduler">
                            <Person fontSize="large" />
                            <Typography variant="caption">
                                Radnici
                            </Typography>
                        </IconButton>
                    </Link>
                    <Link to={REACT_ROUTES.CUSTOMERS}>
                        <IconButton className={button} edge="start" aria-label="scheduler">
                            <Group fontSize="large" />
                            <Typography variant="caption">
                                Klijenti
                            </Typography>
                        </IconButton>
                    </Link>
                    <Link to={REACT_ROUTES.PLACES}>
                        <IconButton className={button} edge="start" aria-label="scheduler">
                            <Room fontSize="large" />
                            <Typography variant="caption">
                                Mesta
                            </Typography>
                        </IconButton>
                    </Link>
                    <Link to={REACT_ROUTES.ARTICLE_TABS}>
                        <IconButton className={button} edge="start" aria-label="scheduler">
                            <RoomService fontSize="large" />
                            <Typography variant="caption">
                                Usluge
                            </Typography>
                        </IconButton>
                    </Link>
                    <Link to={REACT_ROUTES.AREAS}>
                        <IconButton className={button} edge="start" aria-label="scheduler">
                            <EventSeat fontSize="large" />
                            <Typography variant="caption">
                                Oblasti
                            </Typography>
                        </IconButton>
                    </Link>
                    <Link to={REACT_ROUTES.SUB_AREAS}>
                        <IconButton className={button} edge="start" aria-label="scheduler">
                            <GroupWork fontSize="large" />
                            <Typography variant="caption">
                                Dijagnoze
                            </Typography>
                        </IconButton>
                    </Link>
                    <Link to={REACT_ROUTES.THERAPIES}>
                        <IconButton className={button} edge="start" aria-label="scheduler">
                            <LocalHospital fontSize="large" />
                            <Typography variant="caption">
                                Terapije
                            </Typography>
                        </IconButton>
                    </Link>
                    <Link to={REACT_ROUTES.PROTOCOLS}>
                        <IconButton className={button} edge="start" aria-label="scheduler">
                            <Assignment fontSize="large" />
                            <Typography variant="caption">
                                Protokoli
                            </Typography>
                        </IconButton>
                    </Link>
                    {(isAdmin === true || isManager === true) &&
                        <>
                            <Link to={REACT_ROUTES.REPORT_TABS}>
                                <IconButton className={button} edge="start" aria-label="scheduler">
                                    <Assessment fontSize="large" />
                                    <Typography variant="caption">
                                        Izveštaji
                                    </Typography>
                                </IconButton>
                            </Link>
                            <Link to={REACT_ROUTES.EXPENSE_TABS}>
                                <IconButton className={button} edge="start" aria-label="scheduler">
                                    <Receipt fontSize="large" />
                                    <Typography variant="caption">
                                        Troškovi
                                    </Typography>
                                </IconButton>
                            </Link>
                            <Link to={REACT_ROUTES.MLPS}>
                                <IconButton className={button} edge="start" aria-label="scheduler">
                                    <ImportContacts fontSize="large" />
                                    <Typography variant="caption">
                                        MLP
                                    </Typography>
                                </IconButton>
                            </Link>
                        </>
                    }
                </>
            }
            <Button className={clsx(button, buttonRight)} aria-controls="fade-menu" aria-haspopup="true" color="primary" onClick={handleClick}>
                Više opcija <MoreVert />
            </Button>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {(isAdmin === true || isManager === true) && [
                    <MenuItem key="addUser" onClick={handleAddUserClick}>
                        Dodaj korisnika
                    </MenuItem>,
                    <MenuItem key="settings" onClick={handleSettings}>
                        Podešavanja
                    </MenuItem>
                ]}
                <MenuItem onClick={handleExitClick}>Odjava</MenuItem>
            </Menu>
        </Toolbar>
    );

    const renderMobileToolbar = () => (
        !matches &&
            <Toolbar className={toolbar}>
                <Button className={clsx(button, buttonRight)} aria-controls="fade-menu" aria-haspopup="true" color="primary" onClick={handleClick}>
                    <MenuIcon fontSize="large" />
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem component={Link} to={REACT_ROUTES.SCHEDULER}>Zakazivanje</MenuItem>
                    {isDoctor === false &&
                        <div>
                            <MenuItem component={Link} to={REACT_ROUTES.WORKERS}>Radnici</MenuItem>
                            <MenuItem component={Link} to={REACT_ROUTES.CUSTOMERS}>Klijenti</MenuItem>
                            <MenuItem component={Link} to={REACT_ROUTES.PLACES}>Mesta</MenuItem>
                            <MenuItem component={Link} to={REACT_ROUTES.ARTICLE_TABS}>Usluge</MenuItem>
                            <MenuItem component={Link} to={REACT_ROUTES.AREAS}>Oblasti</MenuItem>
                            <MenuItem component={Link} to={REACT_ROUTES.SUB_AREAS}>Dijagnoze</MenuItem>
                            <MenuItem component={Link} to={REACT_ROUTES.THERAPIES}>Terapije</MenuItem>
                            <MenuItem component={Link} to={REACT_ROUTES.PROTOCOLS}>Protokoli</MenuItem>
                            {(isAdmin === true || isManager === true) &&
                                <>
                                    <MenuItem component={Link} to={REACT_ROUTES.REPORT_TABS}>Izveštaji</MenuItem>
                                    <MenuItem component={Link} to={REACT_ROUTES.EXPENSE_TABS}>Troškovi</MenuItem>
                                    <MenuItem onClick={handleAddUserClick}>Dodaj korisnika</MenuItem>
                                </>
                            }
                        </div>
                    }
                    <MenuItem onClick={handleExitClick}>Odjava</MenuItem>
                </Menu>
            </Toolbar>
    )

	return (
		<AppBar position="static">
            <CssBaseline />
            {renderDesktopToolbar()}
            {renderMobileToolbar()}
		</AppBar>
	);
};

Header.propTypes = {
    user: PropTypes.object
};

const mapStateToProps = (state) => ({
    user: state.user
});

export default connect(mapStateToProps)(Header);
